"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var store_1 = require("@ngrx/store");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var idm_validation_calculation_service_client_js_1 = require("@synisys/idm-validation-calculation-service-client-js");
var idm_workflow_service_client_js_1 = require("@synisys/idm-workflow-service-client-js");
var skynet_store_currencies_api_1 = require("@synisys/skynet-store-currencies-api");
var combineLatest_1 = require("rxjs/observable/combineLatest");
var from_1 = require("rxjs/observable/from");
var of_1 = require("rxjs/observable/of");
var zip_1 = require("rxjs/observable/zip");
var operators_1 = require("rxjs/operators");
var ReplaySubject_1 = require("rxjs/ReplaySubject");
var noop_1 = require("rxjs/util/noop");
var __1 = require("..");
var utilities_1 = require("../../../shared/utilities");
var service_1 = require("../../api/service");
var utilities_2 = require("../../utilities");
var de_serialization_service_1 = require("./de-serialization.service");
var lodash_1 = require("lodash");
var HttpDeService = /** @class */ (function () {
    function HttpDeService(_dataService, _kbService, _languageService, _classifierService, _currentLanguageProvider, _applicationPropertiesService, _validationCalculationService, _dePermissionService, store, _auditService, _messageService, zone) {
        this._dataService = _dataService;
        this._kbService = _kbService;
        this._languageService = _languageService;
        this._classifierService = _classifierService;
        this._currentLanguageProvider = _currentLanguageProvider;
        this._applicationPropertiesService = _applicationPropertiesService;
        this._validationCalculationService = _validationCalculationService;
        this._dePermissionService = _dePermissionService;
        this.store = store;
        this._auditService = _auditService;
        this._messageService = _messageService;
        this.zone = zone;
        this.URL_ENTITY_LOAD_ONE = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", "/entity/", "/", ""], ["", "/entity/", "/", ""])), 'serviceUri', 'systemName', 'entityId');
        this.URL_ENTITY_LOAD_MANY = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", "/entity/", "/flat"], ["", "/entity/", "/flat"])), 'serviceUri', 'systemName');
        this.URL_ENTITY_SEARCH = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", "/search/entities/", ""], ["", "/search/entities/", ""])), 'serviceUri', 'systemName');
        this.URL_ENTITY_ADD = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", "/entity/", ""], ["", "/entity/", ""])), 'serviceUri', 'systemName');
        this.URL_ENTITY_BULK_ACTION = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", "/entities/", ""], ["", "/entities/", ""])), 'serviceUri', 'categoryName');
        this.URL_ENTITY_UPDATE = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", "/entity/", "/", ""], ["", "/entity/", "/", ""])), 'serviceUri', 'systemName', 'entityId');
        this.URL_ENTITY_DELETE = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", "/entity/", "/", ""], ["", "/entity/", "/", ""])), 'serviceUri', 'systemName', 'entityId');
        this.URL_ENTITY_DELETE_INSTANCE = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", "/entity/", "/instance/", ""], ["", "/entity/", "/instance/", ""])), 'serviceUri', 'systemName', 'instanceId');
        this.URL_ENTITY_LOAD_HISTORICAL_ITEMS = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", "/entity/", "/flat/history/", ""], ["", "/entity/", "/flat/history/", ""])), 'serviceUri', 'systemName', 'instanceId');
        this.URL_LOAD_ENTITY_BY_INSTANCE_ID = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", "/entity/", "/instance/", ""], ["", "/entity/", "/instance/", ""])), 'serviceUri', 'systemName', 'entityInstanceId');
        this.URL_CHECK_WF_ACTIONS_EXPRESSIONS = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", "/workflow/", "/", "/action"], ["", "/workflow/", "/", "/action"])), 'serviceUri', 'systemName', 'entityId');
        this.URL_DO_WORKFLOW_ACTION = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", "/workflow/", "/", "/action/", ""], ["", "/workflow/", "/", "/action/", ""])), 'serviceUri', 'systemName', 'entityId', 'actionId');
        this.URL_DO_BULK_WORKFLOW_ACTION = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", "/bulkWorkflow/", "/action/", ""], ["", "/bulkWorkflow/", "/action/", ""])), 'serviceUri', 'categoryName', 'actionId');
        this.URL_GET_CONFIG = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", "/config"], ["", "/config"])), 'serviceUri');
        this.URL_GET_CONFIGS_WITH_PREFIX = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", "/configs"], ["", "/configs"])), 'serviceUri');
        this.URL_DE_DOCUMENT_TOKEN = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", "/token/", "/", "/", ""], ["", "/token/", "/", "/", ""])), 'serviceUri', 'systemName', 'entityId', 'documentSystemName');
        this.URL_DE_DOCUMENT_TOKEN_BY_DOCUMENT_ID = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", "/token/", "/", ""], ["", "/token/", "/", ""])), 'serviceUri', 'systemName', 'documentId');
        this.URL_GET_DEFAULT_ENTITY = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", "/entity/defaults"], ["", "/entity/defaults"])), 'serviceUri');
        this.DE_SERVICE_URI_KEY = 'de-service-url';
        this.DELETED_ENTITY_NAME_PREFIX_MESSAGE = 'de.deleted.name.prefix';
        this.NO_ACCESS_ENTITY_NAME_PREFIX_MESSAGE = 'de.no.access.name.prefix';
        this._deSerializationService = null;
        this._entityBuilder = null;
        this._deSerializationService = new de_serialization_service_1.DeSerializationService(_kbService, _languageService, _classifierService, _dePermissionService, this, _auditService, zone);
        this._entityBuilder = new idm_de_core_frontend_1.EntityBuilder();
    }
    /**
     * Create blank(empty) entity. This function is used when a new entity is created.
     * @param {string} categoryName - The unique identifier for entity.
     * @returns {Promise<Entity>}
     */
    HttpDeService.prototype.createBlankEntity = function (categoryName) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(categoryName);
        return this._deSerializationService.deserializeMainEntity(categoryName, this.getDefaultEntities().pipe(operators_1.map(function (data) {
            var jsonData = data && Object.keys(data).length !== 0
                ? JSON.parse(data)
                : undefined;
            if (!jsonData || !jsonData[categoryName]) {
                return {};
            }
            return jsonData[categoryName];
        }), operators_1.switchMap(function (entity) {
            return _this.setDefaultCurrency(categoryName, entity);
        })));
    };
    /**
     * Creates blank(empty) entity. This function is used when a new entity is created.
     * @param {string} categoryName - The unique identifier for entity.
     * @returns {Observable<Entity>}
     */
    HttpDeService.prototype.createBlankSubEntity = function (categoryName) {
        var _this = this;
        return this._deSerializationService.deserializeSubEntity(categoryName, this.getDefaultEntities().pipe(operators_1.map(function (data) {
            var jsonData = data && Object.keys(data).length !== 0
                ? JSON.parse(data)
                : undefined;
            if (!jsonData || !jsonData[categoryName]) {
                return [];
            }
            return jsonData[categoryName];
        }), operators_1.switchMap(function (entity) {
            return _this.setDefaultCurrency(categoryName, entity);
        })));
    };
    /**
     * Loads item with the given ID of a main entity specified by a systemName.
     * @param {string} systemName - The unique identifier for entity.
     * @param {number} entityId - An identity of the instance to be fetched.
     * @param {boolean} [withTransientFields]
     * @returns {Promise<Entity>} the promise resolving with the entity loaded
     */
    HttpDeService.prototype.loadEntity = function (systemName, entityId, withTransientFields) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(systemName);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(entityId);
        return from_1.from(this._applicationPropertiesService.getProperty(this.DE_SERVICE_URI_KEY)).pipe(operators_1.switchMap(function (serviceUri) {
            var url = _this.URL_ENTITY_LOAD_ONE.replaceTemplate({
                entityId: entityId.toString(),
                serviceUri: serviceUri,
                systemName: systemName,
            });
            var entityDataObservable = _this._currentLanguageProvider
                .getCurrentLanguage()
                .pipe(operators_1.first(), operators_1.switchMap(function (language) {
                var queryParams = [];
                queryParams.push(new idm_de_core_frontend_1.SearchParam('languageId', language.getId()));
                queryParams.push(new idm_de_core_frontend_1.SearchParam('withTransientFields', withTransientFields !== undefined &&
                    withTransientFields));
                return _this._dataService.load(url, queryParams);
            }));
            return _this._deSerializationService.deserializeMainEntity(systemName, entityDataObservable);
        }));
    };
    /**
     * Loads items with the given IDs of a main entity specified by a systemName.
     * @param {string} systemName - The unique identifier for entity.
     * @param {PagingOptions} paging - The paging to serve entries in accordance.
     * @param {string} filterCriteria - json representation of Filter Criteria
     * @returns {Promise<Array<Promise<Entity>>>} the promise resolving with the collection of entities loaded
     */
    HttpDeService.prototype.loadEntities = function (systemName, paging, filterCriteria) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(systemName);
        return from_1.from(this._applicationPropertiesService.getProperty(this.DE_SERVICE_URI_KEY)).pipe(operators_1.switchMap(function (serviceUri) {
            var url = _this.URL_ENTITY_LOAD_MANY.replaceTemplate({
                serviceUri: serviceUri,
                systemName: systemName,
            });
            var entitiesDataObservable = _this._currentLanguageProvider
                .getCurrentLanguage()
                .pipe(operators_1.first(), operators_1.switchMap(function (language) {
                var queryParams = [];
                queryParams.push(new idm_de_core_frontend_1.SearchParam('languageId', language.getId()));
                if (!paging) {
                    paging = new idm_de_core_frontend_1.PagingOptions(0, 100);
                }
                queryParams.push(new idm_de_core_frontend_1.SearchParam('paging', paging));
                queryParams.push(new idm_de_core_frontend_1.SearchParam('filterCriteria', filterCriteria));
                return _this._dataService.load(url, queryParams);
            }));
            return _this._deSerializationService.deserializeEntities(systemName, entitiesDataObservable);
        }));
    };
    /**
     * Loads items with the given IDs of a main entity specified by a categoryName.
     * @param {string} categoryName - Category Name.
     * @param {number[]} instanceIds - Instance ids
     * @param {boolean} withTransientFields - get with transient fields, default false
     * @returns {Promise<Array<Promise<Entity>>>} the promise resolving with the collection of entities loaded
     */
    HttpDeService.prototype.getEntitiesByIds = function (categoryName, instanceIds, withTransientFields) {
        var _this = this;
        var serviceUri$ = from_1.from(this._applicationPropertiesService.getProperty(this.DE_SERVICE_URI_KEY));
        var currentLanguageId$ = this._currentLanguageProvider
            .getCurrentLanguage()
            .pipe(operators_1.first(), operators_1.map(function (language) { return language.getId(); }));
        return combineLatest_1.combineLatest(serviceUri$, currentLanguageId$).pipe(operators_1.first(), operators_1.switchMap(function (data) {
            var serviceUri = data[0];
            var currentLanguageId = data[1];
            var url = _this.URL_ENTITY_BULK_ACTION.replaceTemplate({ serviceUri: serviceUri, categoryName: categoryName });
            var queryParams = [];
            queryParams.push(new idm_de_core_frontend_1.SearchParam('languageId', currentLanguageId));
            if (withTransientFields !== undefined) {
                queryParams.push(new idm_de_core_frontend_1.SearchParam('withTransientFields', withTransientFields));
            }
            if (instanceIds) {
                queryParams.push(new idm_de_core_frontend_1.SearchParam('ids', instanceIds.join()));
            }
            var entitiesDataObservable = _this._dataService.load(url, queryParams);
            return _this._deSerializationService.deserializeEntities(categoryName, entitiesDataObservable);
        }));
    };
    HttpDeService.prototype.getEntitiesByIdsRaw = function (categoryName, instanceIds, withTransientFields, fieldSystemNames) {
        var _this = this;
        var serviceUri$ = from_1.from(this._applicationPropertiesService.getProperty(this.DE_SERVICE_URI_KEY));
        var currentLanguageId$ = this._currentLanguageProvider
            .getCurrentLanguage()
            .pipe(operators_1.first(), operators_1.map(function (language) { return language.getId(); }));
        return combineLatest_1.combineLatest(serviceUri$, currentLanguageId$).pipe(operators_1.first(), operators_1.switchMap(function (data) {
            var serviceUri = data[0];
            var currentLanguageId = data[1];
            var url = _this.URL_ENTITY_BULK_ACTION.replaceTemplate({ serviceUri: serviceUri, categoryName: categoryName });
            var queryParams = [];
            queryParams.push(new idm_de_core_frontend_1.SearchParam('languageId', currentLanguageId));
            if (withTransientFields !== undefined) {
                queryParams.push(new idm_de_core_frontend_1.SearchParam('withTransientFields', withTransientFields));
            }
            if (fieldSystemNames) {
                queryParams.push(new idm_de_core_frontend_1.SearchParam('metaFields', fieldSystemNames));
            }
            if (instanceIds) {
                queryParams.push(new idm_de_core_frontend_1.SearchParam('ids', instanceIds.join()));
            }
            return _this._dataService.load(url, queryParams);
        }));
    };
    /**
     * Serializes and saves the newly created entity item.
     * @param {string} systemName - The unique identifier for entity.
     * @param {Entity} entity - The serialized entity item to be saved.
     * @returns {Promise<ServiceResponse<Entity>>}
     */
    HttpDeService.prototype.add = function (systemName, entity) {
        var _this = this;
        var queryParams;
        return from_1.from(this._applicationPropertiesService.getProperty(this.DE_SERVICE_URI_KEY)).pipe(operators_1.switchMap(function (serviceUri) {
            var url = _this.URL_ENTITY_ADD.replaceTemplate({
                serviceUri: serviceUri,
                systemName: systemName,
            });
            return _this._currentLanguageProvider.getCurrentLanguage().pipe(operators_1.first(), operators_1.switchMap(function (language) {
                queryParams = [];
                queryParams.push(new idm_de_core_frontend_1.SearchParam('languageId', language.getId()));
                return _this._deSerializationService.serializeEntity(systemName, entity);
            }), operators_1.switchMap(function (data) {
                return _this._dataService.add(url, data, queryParams);
            }), operators_1.switchMap(function (data) {
                _this._deSerializationService.resetCaches();
                return _this._deSerializationService.deserializeMainEntityWithMeta(systemName, data);
            }));
        }));
    };
    /**
     * Serializes and saves the newly created entities
     */
    HttpDeService.prototype.bulkAdd = function (categoryName, entities, raiseEvent, enableCrossMasterValidations, withOneTransaction, deserializableFields) {
        var _this = this;
        return from_1.from(this._applicationPropertiesService.getProperty(this.DE_SERVICE_URI_KEY)).pipe(operators_1.switchMap(function (serviceUri) {
            var url = _this.URL_ENTITY_BULK_ACTION.replaceTemplate({
                serviceUri: serviceUri,
                categoryName: categoryName,
            });
            return _this.bulkSaveUpdateHelp(categoryName, entities, true, raiseEvent, enableCrossMasterValidations, withOneTransaction).pipe(operators_1.switchMap(function (result) {
                return _this._dataService
                    .add(url, result['payload'], result['queryParams'])
                    .pipe(operators_1.map(function (entitiesData) {
                    return !deserializableFields
                        ? entitiesData
                        : entitiesData.map(function (entityData) {
                            var result = {};
                            Object.keys(entityData.data)
                                .filter(function (fieldSystemName) {
                                return deserializableFields // filter only given fields from entity
                                    .map(function (deserializableField) {
                                    return deserializableField.getSystemName();
                                })
                                    .indexOf(fieldSystemName) !== -1;
                            })
                                .forEach(function (filteredFieldSystemName) {
                                return (result[filteredFieldSystemName] =
                                    entityData.data[filteredFieldSystemName]);
                            });
                            entityData.data = result;
                            return entityData;
                        });
                }), operators_1.switchMap(function (entitiesData) {
                    var response = Array.from(entitiesData).map(function (entityData) {
                        var serviceResponse = new __1.ServiceResponseDefault();
                        serviceResponse.setMeta(utilities_2.deserializeMeta(entityData.meta));
                        serviceResponse.setData(entityData.data);
                        return serviceResponse;
                    });
                    return of_1.of(response);
                }));
            }), operators_1.catchError(function (err) {
                console.log(err);
                return of_1.of(null);
            }));
        }));
    };
    /**
     * Serializes and saves the modified entity item.
     * @param {string} systemName - The unique identifier for entity.
     * @param {Entity} entity - The entity item to be saved.
     * @returns {Promise<ServiceResponse<Entity>>}
     */
    HttpDeService.prototype.update = function (systemName, entity) {
        var _this = this;
        var queryParams;
        return from_1.from(this._applicationPropertiesService.getProperty(this.DE_SERVICE_URI_KEY)).pipe(operators_1.switchMap(function (serviceUri) {
            var url = _this.URL_ENTITY_UPDATE.replaceTemplate({
                entityId: entity.getId().toString(),
                serviceUri: serviceUri,
                systemName: systemName,
            });
            return _this._currentLanguageProvider.getCurrentLanguage().pipe(operators_1.first(), operators_1.switchMap(function (language) {
                queryParams = [];
                queryParams.push(new idm_de_core_frontend_1.SearchParam('languageId', language.getId()));
                return _this._deSerializationService.serializeEntity(systemName, entity);
            }), operators_1.switchMap(function (data) {
                return _this._dataService.update(url, data, queryParams);
            }), operators_1.switchMap(function (data) {
                _this._deSerializationService.resetCaches();
                return _this._deSerializationService.deserializeMainEntityWithMeta(systemName, data);
            }));
        }));
    };
    /**
     * Serializes and saves already created items
     */
    HttpDeService.prototype.bulkUpdate = function (categoryName, entities, raiseEvent, enableCrossMasterValidations, withOneTransaction) {
        var _this = this;
        var entities$ = combineLatest_1.combineLatest(from_1.from(this._applicationPropertiesService.getProperty(this.DE_SERVICE_URI_KEY)), this.bulkSaveUpdateHelp(categoryName, entities, false, raiseEvent, enableCrossMasterValidations, withOneTransaction)).pipe(operators_1.first(), operators_1.switchMap(function (data) {
            var serviceUri = data[0];
            var url = _this.URL_ENTITY_BULK_ACTION.replaceTemplate({
                serviceUri: serviceUri,
                categoryName: categoryName,
            });
            return _this._dataService.update(url, data[1]['payload'], data[1]['queryParams']);
        }));
        var instanceMetaField$ = this._kbService
            .getMetaFields(categoryName)
            .pipe(operators_1.map(function (metaFields) {
            return metaFields.filter(function (metaField) {
                return metaField.getType() ===
                    idm_kb_service_client_js_1.MetaFieldType.INTEGER_INSTANCE;
            })[0];
        }));
        return combineLatest_1.combineLatest(entities$, instanceMetaField$).pipe(operators_1.first(), operators_1.map(function (data) {
            var response = data[0];
            var instanceMetaField = data[1];
            return new Map(Array.from(response).map(function (entityData) { return [
                entityData['data'][instanceMetaField.getSystemName()],
                utilities_2.deserializeMeta(entityData['meta']),
            ]; }));
        }));
    };
    /**
     * Deletes the entity item.
     * @deprecated Since version 1.3.0. Use {@link #HttpDeService.deleteById} instead.
     * @param {string} systemName - The unique identifier for entity.
     * @param {Entity} entity - The entity item to be deleted.
     * @returns {Observable<any>}
     */
    HttpDeService.prototype.delete = function (systemName, entity) {
        return this.deleteById(systemName, entity.getId());
    };
    /**
     * Deletes the entity item.
     * @param {string} systemName - The unique identifier for entity.
     * @param {number} entityId - The ID of entity item to be deleted.
     * @returns {Observable<any>}
     */
    HttpDeService.prototype.deleteById = function (systemName, entityId) {
        var _this = this;
        return from_1.from(this._applicationPropertiesService.getProperty(this.DE_SERVICE_URI_KEY)).pipe(operators_1.switchMap(function (serviceUri) {
            var url = _this.URL_ENTITY_DELETE.replaceTemplate({
                entityId: entityId.toString(),
                serviceUri: serviceUri,
                systemName: systemName,
            });
            return _this._currentLanguageProvider.getCurrentLanguage().pipe(operators_1.first(), operators_1.switchMap(function (language) {
                var queryParams = [];
                queryParams.push(new idm_de_core_frontend_1.SearchParam('languageId', language.getId()));
                return _this._dataService.delete(url, queryParams);
            }));
        }));
    };
    /**
     * Deletes the entity item.
     * @param {string} systemName - The unique identifier for entity.
     * @param {number} instanceId - The Instance ID of entity item to be deleted.
     * @returns {Observable<any>}
     */
    HttpDeService.prototype.deleteByInstanceId = function (systemName, instanceId) {
        var _this = this;
        return from_1.from(this._applicationPropertiesService.getProperty(this.DE_SERVICE_URI_KEY)).pipe(operators_1.switchMap(function (serviceUri) {
            var url = _this.URL_ENTITY_DELETE_INSTANCE.replaceTemplate({
                instanceId: instanceId.toString(),
                serviceUri: serviceUri,
                systemName: systemName,
            });
            return _this._currentLanguageProvider.getCurrentLanguage().pipe(operators_1.first(), operators_1.switchMap(function (language) {
                var queryParams = [];
                queryParams.push(new idm_de_core_frontend_1.SearchParam('languageId', language.getId()));
                return _this._dataService.delete(url, queryParams);
            }));
        }));
    };
    /**
     * Loads history versions and their count.
     *
     * @param {string} systemName - The unique identifier for entity.
     * @param {number} instanceId - The instance id which versions must be load.
     * @param {PagingOptions} pagingOptions - The pagingOptions to serve entity history in accordance.
     * @param {SortingOptions} [sortingOptions] - The sortingOptions to serve entity history in accordance.
     * @param {string[]} [loadableFields] - Entity fields which must be load.
     *                                      If array is empty, null undefined - load all fields
     *
     * @returns {Promise<ServiceResponse<Entity[]>>} the promise resolving with the history loaded
     */
    HttpDeService.prototype.loadHistoricalEntityItems = function (systemName, instanceId, pagingOptions, sortingOptions, loadableFields) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(systemName);
        return from_1.from(this._applicationPropertiesService.getProperty(this.DE_SERVICE_URI_KEY)).pipe(operators_1.switchMap(function (serviceUri) {
            var url = _this.URL_ENTITY_LOAD_HISTORICAL_ITEMS.replaceTemplate({
                instanceId: instanceId.toString(),
                serviceUri: serviceUri,
                systemName: systemName,
            });
            var entitiesDataObservable = _this._currentLanguageProvider
                .getCurrentLanguage()
                .pipe(operators_1.first(), operators_1.switchMap(function (language) {
                var queryParams = [];
                queryParams.push(new idm_de_core_frontend_1.SearchParam('languageId', language.getId()));
                if (pagingOptions !== undefined &&
                    pagingOptions !== null) {
                    queryParams.push(new idm_de_core_frontend_1.SearchParam('paging', {
                        limit: pagingOptions.limit,
                        offset: pagingOptions.offset,
                    }));
                }
                if (loadableFields !== undefined &&
                    loadableFields !== null &&
                    loadableFields.length > 0) {
                    queryParams.push(new idm_de_core_frontend_1.SearchParam('metaFields', loadableFields.toString()));
                }
                if (sortingOptions !== undefined &&
                    sortingOptions !== null) {
                    queryParams.push(new idm_de_core_frontend_1.SearchParam('sortField', sortingOptions.sortField));
                    queryParams.push(new idm_de_core_frontend_1.SearchParam('sortOrder', sortingOptions.sortType === idm_de_core_frontend_1.SortType.ASC
                        ? 'ASC'
                        : 'DESC'));
                }
                return _this._dataService.load(url, queryParams);
            }));
            return _this._deSerializationService.deserializeEntities(systemName, entitiesDataObservable);
        }));
    };
    /**
     * Loads item with the given instance ID of a main entity specified by a systemName.
     * @param {string} systemName
     * @param {number} entityInstanceId
     * @param {boolean} [withTransientFields]
     * @returns {Observable<any>}
     */
    HttpDeService.prototype.loadEntityByInstanceId = function (systemName, entityInstanceId, withTransientFields, fieldSystemNames) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(systemName);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(entityInstanceId);
        return from_1.from(this._applicationPropertiesService.getProperty(this.DE_SERVICE_URI_KEY)).pipe(operators_1.switchMap(function (serviceUri) {
            var url = _this.URL_LOAD_ENTITY_BY_INSTANCE_ID.replaceTemplate({
                entityInstanceId: entityInstanceId.toString(),
                serviceUri: serviceUri,
                systemName: systemName,
            });
            var entityDataObservable = _this._currentLanguageProvider
                .getCurrentLanguage()
                .pipe(operators_1.first(), operators_1.switchMap(function (language) {
                var queryParams = [];
                queryParams.push(new idm_de_core_frontend_1.SearchParam('languageId', language.getId()));
                queryParams.push(new idm_de_core_frontend_1.SearchParam('withTransientFields', withTransientFields !== undefined &&
                    withTransientFields));
                if (fieldSystemNames) {
                    queryParams.push(new idm_de_core_frontend_1.SearchParam('metaFields', fieldSystemNames));
                }
                return _this._dataService.load(url, queryParams);
            }));
            return _this._deSerializationService.deserializeMainEntity(systemName, entityDataObservable, fieldSystemNames);
        }));
    };
    HttpDeService.prototype.getPermittedActions = function (categoryName, entityId) {
        var _this = this;
        var queryParams;
        return from_1.from(this._applicationPropertiesService.getProperty(this.DE_SERVICE_URI_KEY)).pipe(operators_1.switchMap(function (serviceUri) {
            var url = _this.URL_CHECK_WF_ACTIONS_EXPRESSIONS.replaceTemplate({
                serviceUri: serviceUri,
                systemName: categoryName,
                entityId: entityId.toString(),
            });
            return _this._currentLanguageProvider.getCurrentLanguage().pipe(operators_1.first(), operators_1.switchMap(function (language) {
                queryParams = [];
                queryParams.push(new idm_de_core_frontend_1.SearchParam('languageId', language.getId()));
                return _this._dataService
                    .load(url, queryParams)
                    .pipe(operators_1.map(function (actionDtos) {
                    return actionDtos.map(function (actionDto) {
                        return new idm_workflow_service_client_js_1.ActionDto(actionDto.id, _this.convertObjectToMap(actionDto.name), _this.convertObjectToMap(actionDto.description || {}), actionDto.initialStateId, actionDto.targetStateId, actionDto.formId);
                    });
                }));
            }));
        }));
    };
    /**
     * Does workflow action with the given entity and action ID.
     * @param {string} systemName
     * @param {Entity} entity
     * @param {number} actionId
     * @returns {Observable<any>}
     */
    HttpDeService.prototype.doWorkflowAction = function (systemName, entity, actionId) {
        var _this = this;
        var queryParams;
        return from_1.from(this._applicationPropertiesService.getProperty(this.DE_SERVICE_URI_KEY)).pipe(operators_1.switchMap(function (serviceUri) {
            var url = _this.URL_DO_WORKFLOW_ACTION.replaceTemplate({
                actionId: actionId.toString(),
                entityId: entity.getId().toString(),
                serviceUri: serviceUri,
                systemName: systemName,
            });
            return _this._currentLanguageProvider.getCurrentLanguage().pipe(operators_1.first(), operators_1.switchMap(function (language) {
                queryParams = [];
                queryParams.push(new idm_de_core_frontend_1.SearchParam('languageId', language.getId()));
                return _this._deSerializationService.serializeEntity(systemName, entity);
            }), operators_1.switchMap(function (data) {
                return _this._dataService.update(url, data, queryParams);
            }), operators_1.switchMap(function (data) {
                return _this._deSerializationService.deserializeMainEntityWithMeta(systemName, data);
            }));
        }));
    };
    HttpDeService.prototype.doBulkWorkflowAction = function (categoryName, entityIds, actionId, comment, entity) {
        var _this = this;
        var currentLanguage$ = this._currentLanguageProvider
            .getCurrentLanguage()
            .pipe(operators_1.first());
        var languages$ = this._languageService.getInputLanguages();
        var serviceUri$ = from_1.from(this._applicationPropertiesService.getProperty(this.DE_SERVICE_URI_KEY));
        return zip_1.zip(currentLanguage$, serviceUri$, languages$).pipe(operators_1.switchMap(function (_a) {
            var language = _a[0], serviceUri = _a[1], languages = _a[2];
            var url = _this.URL_DO_BULK_WORKFLOW_ACTION.replaceTemplate({
                actionId: actionId.toString(),
                serviceUri: serviceUri,
                categoryName: categoryName,
            });
            return _this.prepareBulkWFActionBody(categoryName, entityIds, languages, comment, entity).pipe(operators_1.switchMap(function (body) {
                return _this._dataService.update(url, body, [
                    new idm_de_core_frontend_1.SearchParam('languageId', language.getId()),
                ]);
            }));
        }), operators_1.map(function (response) {
            var result = new Map();
            for (var key in response) {
                if (response.hasOwnProperty(key)) {
                    result.set(+key, response[key]);
                }
            }
            return result;
        }));
    };
    /**
     * Validates given Entity for existing validations
     * @param {string} systemName
     * @param {Entity} entity
     * @returns {Observable<any>}
     */
    HttpDeService.prototype.validateEntity = function (systemName, entity) {
        var _this = this;
        return this._deSerializationService
            .serializeEntity(systemName, entity)
            .pipe(operators_1.switchMap(function (entityData) {
            return _this._validationCalculationService.validateEntity(systemName, entityData);
        }));
    };
    /**
     * Validate and Calculate given Entity
     * Returned result (ValidationsCalculationsData) contains ValidationErrors, Calculation Warnings
     * and deserialized MainEntity
     * @param {string} systemName
     * @param {Entity} entity
     * @returns {Observable<ValidationsCalculationsData>}
     */
    HttpDeService.prototype.validateAndCalculateEntity = function (systemName, entity) {
        var _this = this;
        var validationCalculationData;
        return this._deSerializationService
            .serializeEntity(systemName, entity)
            .pipe(operators_1.switchMap(function (entityData) {
            return _this._validationCalculationService.calculateAndValidateEntity(systemName, entityData);
        }), operators_1.switchMap(function (data) {
            validationCalculationData = data;
            return _this._deSerializationService.deserializeMainEntity(systemName, of_1.of(validationCalculationData.getData()));
        }), operators_1.map(function (deserializedEntity) {
            return new idm_validation_calculation_service_client_js_1.ValidationsCalculationsData(validationCalculationData.getValidations(), validationCalculationData.getCalculations(), deserializedEntity);
        }));
    };
    /**
     * Validate and Calculate field of given Entity
     * Returned result (ValidationsCalculationsData) contains ValidationErrors, Calculation Warnings
     * @param {string} systemName
     * @param {string} fieldSystemName
     * @param {Entity} entity
     * @returns {Observable<any>}
     */
    HttpDeService.prototype.validateAndCalculateField = function (systemName, fieldSystemName, entity) {
        var _this = this;
        var validationCalculationData;
        return this._deSerializationService
            .serializeEntity(systemName, entity)
            .pipe(operators_1.switchMap(function (entityData) {
            return _this._validationCalculationService.calculateAndValidateField(systemName, fieldSystemName, entityData);
        }), operators_1.switchMap(function (data) {
            validationCalculationData = data;
            return _this._deSerializationService.deserializeMainEntity(systemName, of_1.of(validationCalculationData.getData()));
        }), operators_1.map(function (deserializedEntity) {
            return new idm_validation_calculation_service_client_js_1.ValidationsCalculationsData(validationCalculationData.getValidations(), validationCalculationData.getCalculations(), deserializedEntity);
        }));
    };
    /**
     * Validates only the field of the given category.
     * @param {string} systemName
     * @param {string} fieldSystemName
     * @param {Entity} entity
     * @returns {Observable<any>}
     */
    HttpDeService.prototype.validateField = function (systemName, fieldSystemName, entity) {
        var _this = this;
        return this._deSerializationService
            .serializeEntity(systemName, entity)
            .pipe(operators_1.switchMap(function (entityData) {
            return _this._validationCalculationService.validateField(systemName, fieldSystemName, entityData);
        }));
    };
    HttpDeService.prototype.getConfig = function (systemName, path, name) {
        var _this = this;
        return from_1.from(this._applicationPropertiesService.getProperty(this.DE_SERVICE_URI_KEY)).pipe(operators_1.switchMap(function (serviceUri) {
            var queryParams = [];
            queryParams.push(new idm_de_core_frontend_1.SearchParam('path', path));
            queryParams.push(new idm_de_core_frontend_1.SearchParam('name', name));
            var url = _this.URL_GET_CONFIG.replaceTemplate({
                serviceUri: serviceUri,
            });
            return _this._dataService.load(url, queryParams);
        }));
    };
    HttpDeService.prototype.getConfigs = function (systemName, prefix) {
        var _this = this;
        return from_1.from(this._applicationPropertiesService.getProperty(this.DE_SERVICE_URI_KEY)).pipe(operators_1.switchMap(function (serviceUri) {
            var queryParams = [];
            queryParams.push(new idm_de_core_frontend_1.SearchParam('prefix', prefix));
            var url = _this.URL_GET_CONFIGS_WITH_PREFIX.replaceTemplate({ serviceUri: serviceUri });
            return _this._dataService.load(url, queryParams);
        }));
    };
    /**
     * Loads document token from de service.
     * @param {string} systemName - systemName of document's parent entity(aka MainEntity).
     * @param {number} entityId - id of document's parent entity
     * @param {string} documentSystemName - systemName of document field
     * @param {string} permissionType - permissionType to get document token. Supported types are DOWNLOAD or UPLOAD
     * @returns {Observable<string>} - Observable of loaded token.
     */
    HttpDeService.prototype.getDocumentToken = function (systemName, entityId, documentSystemName, permissionType) {
        var _this = this;
        if (permissionType === void 0) { permissionType = 'DOWNLOAD'; }
        return from_1.from(this._applicationPropertiesService.getProperty(this.DE_SERVICE_URI_KEY)).pipe(operators_1.switchMap(function (serviceUri) {
            var queryParams = [];
            queryParams.push(new idm_de_core_frontend_1.SearchParam('permissionType', permissionType));
            var loadUrl = _this.URL_DE_DOCUMENT_TOKEN.replaceTemplate({
                documentSystemName: documentSystemName,
                entityId: entityId.toString(),
                serviceUri: serviceUri,
                systemName: systemName,
            });
            return _this._dataService.load(loadUrl, queryParams);
        }));
    };
    HttpDeService.prototype.loadDynamicFormMainEntity = function (categoryName, entityInstanceId) {
        this._deSerializationService.resetCaches();
        return this.loadEntityByInstanceId(categoryName, entityInstanceId, true);
    };
    HttpDeService.prototype.getDocumentTokenByDocumentId = function (systemName, documentId, permissionType) {
        var _this = this;
        if (permissionType === void 0) { permissionType = 'DOWNLOAD'; }
        return from_1.from(this._applicationPropertiesService.getProperty(this.DE_SERVICE_URI_KEY)).pipe(operators_1.switchMap(function (serviceUri) {
            var queryParams = [];
            queryParams.push(new idm_de_core_frontend_1.SearchParam('permissionType', permissionType));
            var loadUrl = _this.URL_DE_DOCUMENT_TOKEN_BY_DOCUMENT_ID.replaceTemplate({
                serviceUri: serviceUri,
                systemName: systemName,
                documentId: documentId.toString(),
            });
            return _this._dataService.load(loadUrl, queryParams);
        }));
    };
    HttpDeService.prototype.getEntityName = function (categorySystemName, entity, separator) {
        var _this = this;
        if (separator === void 0) { separator = ' '; }
        if (entity === null) {
            return of_1.of(null);
        }
        var currentLanguage$ = this._currentLanguageProvider
            .getCurrentLanguage()
            .pipe(operators_1.first());
        var nameMetaFieldIds$ = this._kbService.getNameMetaFieldIds(categorySystemName);
        var deletedMessage$ = this._messageService.getMessage(this.DELETED_ENTITY_NAME_PREFIX_MESSAGE);
        var noAccessMessage$ = this._messageService.getMessage(this.NO_ACCESS_ENTITY_NAME_PREFIX_MESSAGE);
        return combineLatest_1.combineLatest(currentLanguage$, nameMetaFieldIds$, deletedMessage$, noAccessMessage$).pipe(operators_1.flatMap(function (data) {
            var language = data[0];
            var nameMetaFieldIds = data[1];
            var deletedPrefix = data[2];
            var noAccessPrefix = data[3];
            var names$ = [];
            nameMetaFieldIds.forEach(function (nameMetaFieldId) {
                var nameMetaField$ = _this._kbService.getMetaFieldByMetaFieldId(nameMetaFieldId);
                names$.push(nameMetaField$.map(function (nameMetaField) {
                    return idm_de_core_frontend_1.stringifyFieldValue(nameMetaField, entity.getProperty(nameMetaField.getSystemName()).value, language);
                }));
            });
            if (names$.length > 0) {
                return zip_1.zip.apply(void 0, names$).pipe(operators_1.map(function (names) {
                    var name;
                    name = entity.isDeleted()
                        ? deletedPrefix +
                            names.filter(Boolean).join(separator)
                        : names.filter(Boolean).join(separator);
                    return entity.hasNoAccess()
                        ? noAccessPrefix + name
                        : name;
                }));
            }
            else {
                return of_1.of('');
            }
        }));
    };
    HttpDeService.prototype.searchEntities = function (systemName, pagingCriteria, filterCriteria, flat, withTransientFields, onlySearchableFields) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(systemName);
        return from_1.from(this._applicationPropertiesService.getProperty(this.DE_SERVICE_URI_KEY)).pipe(operators_1.switchMap(function (serviceUri) {
            var url = _this.URL_ENTITY_SEARCH.replaceTemplate({
                serviceUri: serviceUri,
                systemName: systemName,
            });
            var entitiesDataObservable = _this._currentLanguageProvider
                .getCurrentLanguage()
                .pipe(operators_1.first(), operators_1.switchMap(function (language) {
                var queryParams = [];
                queryParams.push(new idm_de_core_frontend_1.SearchParam('languageId', language.getId()));
                queryParams.push(new idm_de_core_frontend_1.SearchParam('flat', flat || false));
                queryParams.push(new idm_de_core_frontend_1.SearchParam('withTransientFields', withTransientFields || false));
                queryParams.push(new idm_de_core_frontend_1.SearchParam('onlySearchableFields', onlySearchableFields || false));
                return _this._dataService.add(url, { filterCriteria: filterCriteria, pagingCriteria: pagingCriteria }, queryParams);
            }));
            return _this._deSerializationService.deserializeEntities(systemName, entitiesDataObservable);
        }));
    };
    HttpDeService.prototype.convertObjectToMap = function (obj) {
        var strMap = new Map();
        for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
            var prop = _a[_i];
            strMap.set(Number(prop), obj[prop]);
        }
        return strMap;
    };
    HttpDeService.prototype.getDefaultEntities = function () {
        var _this = this;
        if (!this.defaultEntities$) {
            this.defaultEntities$ = new ReplaySubject_1.ReplaySubject(1);
            from_1.from(this._applicationPropertiesService.getProperty(this.DE_SERVICE_URI_KEY))
                .pipe(operators_1.switchMap(function (serviceUri) {
                var url = _this.URL_GET_DEFAULT_ENTITY.replaceTemplate({ serviceUri: serviceUri });
                return _this._dataService.load(url);
            }), operators_1.tap(function (data) { return _this.defaultEntities$.next(data); }))
                .subscribe(noop_1.noop, console.error);
        }
        return this.defaultEntities$;
    };
    HttpDeService.prototype.bulkSaveUpdateHelp = function (categoryName, entities, create, raiseEvent, enableCrossMasterValidations, withOneTransaction) {
        var queryParams = [];
        if (raiseEvent !== undefined) {
            queryParams.push(new idm_de_core_frontend_1.SearchParam('raiseEvent', raiseEvent));
        }
        if (enableCrossMasterValidations !== undefined) {
            queryParams.push(new idm_de_core_frontend_1.SearchParam('enableCrossMasterValidations', enableCrossMasterValidations));
        }
        if (withOneTransaction !== undefined) {
            queryParams.push(new idm_de_core_frontend_1.SearchParam('withOneTransaction', withOneTransaction));
        }
        var serializedEntities$ = this._deSerializationService.bulkSerializeEntities(categoryName, entities, create);
        var currentLanguage$ = this._currentLanguageProvider
            .getCurrentLanguage()
            .pipe(operators_1.first());
        return combineLatest_1.combineLatest(serializedEntities$, currentLanguage$).pipe(operators_1.first(), operators_1.map(function (data) {
            queryParams.push(new idm_de_core_frontend_1.SearchParam('languageId', data[1].getId()));
            return { payload: data[0], queryParams: queryParams };
        }));
    };
    HttpDeService.prototype.prepareBulkWFActionBody = function (categoryName, entityIds, languages, comment, entity) {
        var _this = this;
        var body = {};
        body['instanceIds'] = entityIds;
        body['lastActionComment'] = !lodash_1.isNil(comment)
            ? idm_de_core_frontend_1.serializeMultilingualString(comment, languages)
            : {};
        return !lodash_1.isNil(entity)
            ? this._deSerializationService
                .serializeEntity(categoryName, entity)
                .pipe(operators_1.switchMap(function (entityData) {
                return zip_1.zip(of_1.of(entityData), _this._kbService.getWorkflowStateMetaField(categoryName));
            }), operators_1.map(function (_a) {
                var entityData = _a[0], wfMetaField = _a[1];
                var specifiedEntityData = {};
                lodash_1.forIn(entityData, function (value, key) {
                    if (lodash_1.isArray(value) && !lodash_1.isEmpty(value)) {
                        specifiedEntityData[key] = value;
                    }
                    if (lodash_1.isObject(value) &&
                        !lodash_1.isArray(value) &&
                        !lodash_1.isEmpty(value) &&
                        lodash_1.values(value).find(function (v) { return !lodash_1.isNil(v); })) {
                        specifiedEntityData[key] = value;
                    }
                    if (!lodash_1.isArray(value) &&
                        !lodash_1.isObject(value) &&
                        !lodash_1.isNil(value)) {
                        specifiedEntityData[key] = value;
                    }
                });
                specifiedEntityData = !lodash_1.isNil(wfMetaField)
                    ? lodash_1.omit(specifiedEntityData, [
                        wfMetaField.getSystemName(),
                    ])
                    : specifiedEntityData;
                body['fields'] = entityIds.reduce(function (acc, id) {
                    acc[id] = specifiedEntityData;
                    return acc;
                }, {});
                return body;
            }))
            : of_1.of(body);
    };
    HttpDeService.prototype.setDefaultCurrency = function (categoryName, entity) {
        var _this = this;
        if (this.store === undefined) {
            return of_1.of(entity);
        }
        return this._kbService.getMetaFields(categoryName).pipe(operators_1.first(), operators_1.switchMap(function (fields) {
            var newValues$ = fields
                .map(function (field) {
                if (entity[field.getSystemName()] !== null &&
                    entity[field.getSystemName()] !== undefined) {
                    return undefined;
                }
                switch (field.getType()) {
                    case idm_kb_service_client_js_1.MetaFieldType.WORKFLOW_STATE:
                    case idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY:
                    case idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER:
                        // TODO
                        return undefined;
                    case idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY:
                    case idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT:
                        // TODO
                        return undefined;
                    case idm_kb_service_client_js_1.MetaFieldType.MONEY:
                        return skynet_store_currencies_api_1.getDefaultCurrency(_this.store).pipe(operators_1.first(), operators_1.map(function (value) {
                            return (_a = {},
                                _a[field.getSystemName()] = {
                                    amount: undefined,
                                    currencyId: value.id,
                                },
                                _a);
                            var _a;
                        }));
                    case idm_kb_service_client_js_1.MetaFieldType.ACCOUNTING:
                        return skynet_store_currencies_api_1.getDefaultCurrency(_this.store).pipe(operators_1.first(), operators_1.map(function (value) {
                            return (_a = {},
                                _a[field.getSystemName()] = {
                                    originalMoney: {
                                        amount: undefined,
                                        currencyId: value.id,
                                    },
                                    rateToDefault: 1,
                                    timestamp: utilities_1.todayUTC(),
                                },
                                _a);
                            var _a;
                        }));
                    default:
                        return undefined;
                }
            })
                .filter(function (v) { return v !== undefined; });
            if (newValues$.length === 0) {
                return of_1.of(entity);
            }
            return combineLatest_1.combineLatest(newValues$).pipe(operators_1.map(function (newValues) { return Object.assign.apply(Object, [{}].concat(newValues)); }), operators_1.map(function (newValues) { return Object.assign(entity, newValues); }));
        }));
    };
    HttpDeService = __decorate([
        core_1.Injectable(),
        __param(8, core_1.Optional()),
        __metadata("design:paramtypes", [service_1.DataService,
            idm_kb_service_client_js_1.KbService,
            idm_message_language_service_client_js_1.LanguageService,
            idm_classifier_service_client_js_1.ClassifierService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            idm_validation_calculation_service_client_js_1.ValidationService,
            service_1.DePermissionService,
            store_1.Store,
            idm_classifier_service_client_js_1.EntityAuditService,
            idm_message_language_service_client_js_1.MessageService,
            core_1.NgZone])
    ], HttpDeService);
    return HttpDeService;
}());
exports.HttpDeService = HttpDeService;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18;
//# sourceMappingURL=http-de.service.js.map